import React from "react";
import tw from "twin.macro";

/*
 * Page wrapper used by every route.
 *
 * This used to slide each section in from alternating sides (x: ±150% with a
 * spring) once it scrolled into view. It was removed because:
 *  - every section shipped off-screen in the prerendered HTML (translateX
 *    ±624px), so content was invisible until JavaScript ran and the visitor
 *    scrolled to it - delaying exactly what people came to read;
 *  - it ignored prefers-reduced-motion entirely;
 *  - for a product HR teams trust with harassment reports, calm reads as
 *    credible and swooping sections read as a template.
 *
 * Pages still pass a `disabled` prop; it is accepted and ignored, so no page needs changing.
 */
const StyledDiv = tw.div`min-h-screen text-secondary-500 p-8 overflow-hidden`;

export default ({ children }) => <StyledDiv className="App">{children}</StyledDiv>;
